import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const ruleService = {
    list: async (body = {}, params = {}) => axios.post(API_KEEPER + "/alarm-rules/search", body, { params }).then(({ data }) => data).catch((err) => { throw err }),

    create: async (payload) => axios.post(API_KEEPER + "/alarm-rules", payload).then(({ data }) => data).catch((err) => { throw err }),

    update: async (id, payload) => axios.put(API_KEEPER + `/alarm-rules/${id}`, payload).then(({ data }) => data).catch((err) => { throw err }),

    remove: async (id) => axios.delete(API_KEEPER + `/alarm-rules/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    formInfo: async (id) => axios.get(API_KEEPER + `/alarm-rules/form-info/${id ?? ""}`).then(({ data }) => data).catch((err) => { throw err }),
}

export default ruleService;